import { $channel } from "@/controllers/channel";
import { $cookie } from "@/cookie";
import { Draggable } from "@/elem/drag";
import { FrameCore } from "@/frame/core";
import float_temp from "@/template/floating.hz";
import float_iframe from "@/template/floating_iframe.hz";
import float_temp_lr from "@/template/floating_lr.hz";
import float_temp_m from "@/template/floating_m.hz";
import float_temp_ud from "@/template/floating_ud.hz";
import { getDomain } from "@/utils/domain";
import { isMobile } from "@/utils/ismobile";

import type { ChannelEmbedItem } from "@/interface/api";
import type { SdkOptions } from "@/interface/sdk";

export class FloatingController extends FrameCore {
  data = {
    isShow: false,
    icon: "",
    style: "",
    color: "",
    title: "",
    iframeUrl: "",
    list: [
      { id: 1, name: "abc" },
      { id: 2, name: "def" },
    ],
    list2: [
      { id: 1, name: "ABC" },
      { id: 2, name: "DEF" },
    ],
  };

  url = "https://ai-search.smarket.com.cn/chat/";
  type: ChannelEmbedItem["type"] = "icon";
  appId = "";
  linkType: SdkOptions["type"] = "link";

  constructor(element: HTMLElement) {
    super(element);
    // document.addEventListener("click", () => {
    //   this.setData({ isShow: !this.data.isShow });
    // });
  }

  generatePositionStyle(
    position: ChannelEmbedItem["position"],
    x: number,
    y: number,
  ): string {
    const styleMap: Record<string, string> = {
      left_bottom: `left: ${x}%; bottom: ${y}%;`,
      right_bottom: `right: ${x}%; bottom: ${y}%;`,
      left_top: `left: ${x}%; top: ${y}%;`,
      right_top: `right: ${x}%; top: ${y}%;`,
    };

    return styleMap[position] || styleMap.right_top;
  }

  async initData(): Promise<boolean> {
    return new Promise((resolve) => {
      $channel.$end.subscribe((res) => {
        const item = isMobile() ? res.wap : res.pc;
        this.setData({
          icon: item.embed_icon,
          style: this.generatePositionStyle(item.position, item.x, item.y),
          color: item.icon_color,
          title: item.embed_title,
          iframeUrl: this.url + this.appId,
        });
        this.type = item.type;
        resolve(true);
      });
    });
  }

  async init(
    o: NonNullable<SdkOptions["floating"]>,
    appId: string,
  ): Promise<void> {
    this.appId = appId;
    await this.initData();
    const temps: Record<ChannelEmbedItem["type"], string> = {
      icon: float_temp + float_iframe,
      icon_text_lr: float_temp_lr + float_iframe,
      icon_text_ud: float_temp_ud + float_iframe,
      icon_m: float_temp_m + float_iframe,
    };
    this.insert(temps[this.type]);
    if (o.drag === undefined || o.drag) {
      const dom = document.querySelector(".hz-content");
      if (dom != null) {
        new Draggable(dom as HTMLElement);
      }
    }
  }

  goto(n: string): void {
    console.log("FloatingController.goto", n);
    if (this.appId != "" && this.appId != undefined) {
      const href = window.location.href;
      const domain = getDomain(href);
      $cookie.set("click_btn", "icon", {
        domain: domain,
      });
      $cookie.set("link_source", href, {
        domain: domain,
      });
      if (this.linkType === "link") {
        window.location.href = this.url + this.appId;
      } else {
        if (!this.data.isShow) {
          this.setData({ isShow: true });
        }
      }
    }
  }

  close(): void {
    this.setData({ isShow: false });
  }

  log(s: string): void {
    console.log("FloatingController.log", s);
  }
}
